__turbopack_context__.v({
  "collapsibleContent": "mobile-order-summary-module-scss-module__GcZDWW__collapsibleContent",
  "mobileOnly": "mobile-order-summary-module-scss-module__GcZDWW__mobileOnly",
  "open": "mobile-order-summary-module-scss-module__GcZDWW__open",
  "productLineItem": "mobile-order-summary-module-scss-module__GcZDWW__productLineItem",
  "quantity": "mobile-order-summary-module-scss-module__GcZDWW__quantity",
  "rotateChevron": "mobile-order-summary-module-scss-module__GcZDWW__rotateChevron",
  "tgtChevron": "mobile-order-summary-module-scss-module__GcZDWW__tgtChevron",
  "toggleButton": "mobile-order-summary-module-scss-module__GcZDWW__toggleButton",
});
